import {
  FaCalendarAlt,
  FaCalendarCheck,
  FaCalendarDay,
  FaCalendarPlus,
  FaCalendarTimes,
  FaUserClock,
  FaUserMd,
  FaUsers,
} from "react-icons/fa";
import CreateVisitFormEntries from "../components/his/visits-form-entries/CreateVisitFormEntries";
import ViewVisitFormEntries from "../components/his/visits-form-entries/ViewVisitFormEntries";
import CreateVisitForm from "../components/his/visits/CreateVisitForm";
import VisitsList from "../components/his/visits/VisitsList";
import { formatDate, formatDateTime } from "../utils/FormateDateTime";
import { sequenceTableTemplate } from "../utils/squenceTableNo";
import IpFormEntriesCreation from "../components/his/patient-profiling/IpFormEntriesCreation";
import { groupByItemType } from "../utils/GroupByItem";
import { data } from "react-router-dom";
import { PayBillItemsTable } from "../components/his/visits/VisitPriceItemsPayBill";
import CreateVisitWithoutSlot from "../components/his/visits/CreateVisitWithoutSlot";
import { t } from "i18next";
import { fetchData } from "../helpers/fetchData";

export const visitsTablesColumns = [
  {
    body: sequenceTableTemplate,
    header: "No",
    style: { width: "3rem" },
  },
  {
    field: "visit_date",
    header: "Visit Date",
    body: (rowData) => formatDateTime(rowData?.order_date),
  },
  {
    field: "patient_name",
    header: "Patient Name",
  },
  {
    field: "practioner_name",
    header: "Practioner Name",
  },
  {
    field: "visit_category",
    header: "Visit Category",
  },
  {
    field: "status",
    header: "Visit Status",
  },
];

export const VisitTabs = (
  t,
  setEligibilityData,
  setSelectedPatient,
  selectedPatient,
  _,
  openDepositForm,
  withoutSlot = false,
  refreshDepositTrigger = 0,
  refreshCreditTrigger = 0,
) => {
  return [
    {
      name: t("OutPatients"),
      content: withoutSlot ? (
        <CreateVisitWithoutSlot
          visit_category="out_patient"
          setEligibilityData={setEligibilityData}
          setSelectedPatient={setSelectedPatient}
          openDepositForm={openDepositForm}
          selectedPatient={selectedPatient}
          refreshCreditTrigger={refreshCreditTrigger}
          refreshDepositTrigger={refreshDepositTrigger}
        />
      ) : (
        <CreateVisitForm
          visit_category="out_patient"
          setEligibilityData={setEligibilityData}
          setSelectedPatient={setSelectedPatient}
          openDepositForm={openDepositForm}
          selectedPatient={selectedPatient}
          refreshDepositTrigger={refreshDepositTrigger}
          refreshCreditTrigger={refreshCreditTrigger}
        />
      ),
    },
    {
      name: t("InPatients"),
      content: withoutSlot ? (
        <CreateVisitWithoutSlot
          visit_category="in_patient"
          setEligibilityData={setEligibilityData}
          setSelectedPatient={setSelectedPatient}
          openDepositForm={openDepositForm}
          selectedPatient={selectedPatient}
          refreshCreditTrigger={refreshCreditTrigger}
          refreshDepositTrigger={refreshDepositTrigger}
        />
      ) : (
        <CreateVisitForm
          visit_category="in_patient"
          setEligibilityData={setEligibilityData}
          setSelectedPatient={setSelectedPatient}
          openDepositForm={openDepositForm}
          selectedPatient={selectedPatient}
          refreshDepositTrigger={refreshDepositTrigger}
          refreshCreditTrigger={refreshCreditTrigger}
        />
      ),
    },
  ];
};

export const visitTypeOptions = (t) => [
  { label: t("Routine checkup"), value: "Routine checkup" },
  { label: t("Follow Up"), value: "Follow Up" },
  { label: t("First Visit"), value: "First Visit" },
  { label: t("Consultation"), value: "Consultation" },
  { label: t("Emergency"), value: "Emergency" },
  { label: t("Procedure"), value: "Procedure" },
  { label: t("Therapy"), value: "Therapy" },
  { label: t("Immunization"), value: "Immunization" },
  { label: t("Surgical"), value: "Surgical" },
  { label: t("Diagnostic test"), value: "Diagnostic test" },
];

export const paymentMethods = (t) => [
  // { label: t("All"), value: "" },
  { label: t("Card"), value: "card" },
  { label: t("Cash"), value: "cash" },
  { label: t("Credit"), value: "credit" },
  { label: t("Bank"), value: "bank" },
  { label: t("Cheque"), value: "cheque" },
  { label: t("Multi Payment"), value: "multi_payment" },
  // { label: t("Deposit"), value: "Deposit" },
];

export const widthdrawPaymentMethods = (t) => [
  { label: t("Cash"), value: "cash" },
  { label: t("Bank"), value: "bank" },
  { label: t("Cheque"), value: "cheque" },
  { label: t("Multi Payment"), value: "multi_payment" },
];

export const cardOptions = [
  {
    label: "Local Card Scheme",
    options: [{ label: "Mada", value: "Mada" }],
  },
  {
    label: "International Card Schemes",
    options: [
      { label: "Visa", value: "visa" },
      { label: "Mastercard", value: "mastercard" },
      { label: "American Express (Amex)", value: "amex" },
      { label: "JCB", value: "jcb" },
      { label: "UnionPay", value: "unionpay" },
      { label: "Diners Club / Discover", value: "diners_discover" },
    ],
  },
  {
    label: "Mobile Wallets / Apps",
    options: [
      { label: "Mada Pay", value: "mada_pay" },
      { label: "Apple Pay", value: "apple_pay" },
      { label: "Google Pay", value: "google_pay" },
      { label: "Samsung Pay", value: "samsung_pay" },
      { label: "STC Pay", value: "stc_pay" },
      { label: "UrPay (Al Rajhi Bank)", value: "urpay" },
      { label: "Alinma Pay", value: "alinma_pay" },
      { label: "NeoLeap", value: "neoleap" },
      { label: "RiyadPay", value: "riyadpay" },
      { label: "Mobily Pay", value: "mobily_pay" },
    ],
  },
  {
    label: "Licensed Payment Gateways / Providers",
    options: [
      { label: "Tap Payments", value: "tap_payments" },
      { label: "PayTabs", value: "paytabs" },
      { label: "BayanPay", value: "bayanpay" },
      { label: "HyperPay", value: "hyperpay" },
      { label: "Moyasar", value: "moyasar" },
      {
        label: "Amazon Payment Services (Payfort)",
        value: "amazon_payment_services",
      },
      { label: "Geidea", value: "geidea" },
      { label: "CASHU", value: "cashu" },
    ],
  },
  {
    label: "Other FinTech & BNPL",
    options: [
      { label: "PayPal", value: "paypal" },
      { label: "Tabby (Buy Now Pay Later)", value: "tabby" },
      { label: "Tamara (Buy Now Pay Later)", value: "tamara" },
      { label: "Finzey", value: "finzey" },
    ],
  },
];

export const cardLabels = (t) => ({
  mada: t("Mada"),

  visa: t("Visa"),
  mastercard: t("Mastercard"),
  amex: t("American Express (Amex)"),
  jcb: t("JCB"),
  unionpay: t("UnionPay"),
  diners_discover: t("Diners Club / Discover"),

  mada_pay: t("Mada Pay"),
  apple_pay: t("Apple Pay"),
  google_pay: t("Google Pay"),
  samsung_pay: t("Samsung Pay"),
  stc_pay: t("STC Pay"),
  urpay: t("UrPay (Al Rajhi Bank)"),
  alinma_pay: t("Alinma Pay"),
  neoleap: t("NeoLeap"),
  riyadpay: t("RiyadPay"),
  mobily_pay: t("Mobily Pay"),

  tap_payments: t("Tap Payments"),
  paytabs: t("PayTabs"),
  bayanpay: t("BayanPay"),
  hyperpay: t("HyperPay"),
  moyasar: t("Moyasar"),
  amazon_payment_services: t("Amazon Payment Services (Payfort)"),
  geidea: t("Geidea"),
  cashu: t("CASHU"),

  paypal: t("PayPal"),
  tabby: t("Tabby (Buy Now Pay Later)"),
  tamara: t("Tamara (Buy Now Pay Later)"),
  finzey: t("Finzey"),
});

export const visitSearchPatientOptionsFormat = (response = []) =>
  response.map((data) => ({
    label: `${data?.full_name} --- ${data?.document_id} --- ${data?.file_no}${data?.old_file_no ? ` --- ${data.old_file_no}` : ""}`,
    value: data?.patient_id,
    patientData: data,
    template: (
      <span>
        {data?.full_name} <span className="text-primary font-bold"> --- </span>
        {data?.document_id}{" "}
        <span className="text-primary font-bold"> --- </span>
        {data?.file_no}
        {data?.old_file_no && (
          <>
            <span className="text-primary font-bold"> --- </span>
            <span className="text-red-500 font-semibold">
              {data.old_file_no}
            </span>
          </>
        )}
      </span>
    ),
  }));

// export const patientInsurancePlansOptionsFormat = (response) => {
//   return response?.map((data) => {
//     console.log(data);

//     return {
//       label: data?.payer_name
//         ? `${data?.payer_name}--${data?.member_card_id}${
//             data?.is_primary ? "  (Primary)" : ""
//           }${data?.eligiblity_status}`
//         : `${data?.name}--${`(  ${data?.member_card_id})`}`,
//       value: data?.his_payer_id || data?.payer_id,
//       payerData: data,
//     };
//   });
// };

export const patientInsuracnePlansOptionsFormat = (response = []) => {
  const plans = Array.isArray(response) ? response : [];

  return plans.map((data) => {
    const payerName = data?.payer_name || data?.name || "Unknown";
    const memberCard = data?.member_card_id ? `${data.member_card_id}` : "";

    const isPrimary = data?.is_primary ? "🟢" : "";
    const eligibilityClass = data?.eligiblity_status
      ? data.eligiblity_status.toLowerCase() === "active" ||
        data.eligiblity_status.toLowerCase() === "eligible"
        ? "bg-green-200"
        : data.eligiblity_status.toLowerCase() === "not-active"
          ? "bg-red-200"
          : ""
      : "";

    const labelText = `${isPrimary}${isPrimary ? " | " : ""}${payerName}${memberCard ? `-${memberCard}` : ""}`;

    return {
      label: labelText,
      template: (
        <div className={`flex items-center gap-2 ${eligibilityClass}`}>
          {isPrimary} {isPrimary ? "|" : ""} {payerName}
          {memberCard ? `-${memberCard}` : ""}
        </div>
      ),
      eligibilityClass,
      value: data?.his_payer_id || data?.payer_id,
      payerData: data,
    };
  });
};

export const patientInsurancePlansID = (response) => {
  return response?.map((data) => {
    return {
      label: data?.payer_name || data?.name,
      value: data?.insurance_plan_id,
      payerData: data,
    };
  });
};

export const patientCashPlansOptionsFormat = (response) => {
  return response?.map((data) => {
    return {
      label: data?.payer_name || data?.name,
      value: data?.payer_id,
      payerData: data,
    };
  });
};

export const practionerOptionsFormat = (response) => {
  return response?.map((data) => {
    const numericId = data?.practitioner_id?.replace(/^pra-/i, "") || "";
    return {
      label: `${data?.name} (${numericId})`,
      value: data?.practitioner_id,
      practionerData: data,
      searchFields: `${numericId} ${data?.name}`,
    };
  });
};

export const nurseOptionsFormat = (response) => {
  return response?.map((data) => {
    return {
      label: data?.name,
      value: data?.nurse_id,
      data: data,
    };
  });
};

export const appointmentVisitTypeOptions = [
  { label: "New Patient", value: "New Patient" },
  { label: "Follow up Patient", value: "Follow up Patient" },
];

export const patientsNameFieldOptionsFormat = (response) => {
  return response?.map((data) => {
    return {
      label: `${data?.full_name} --- ${data?.document_id} --- ${data?.file_no}${data?.old_file_no ? ` --- ${data.old_file_no}` : ""}`,
      value: data?.patient_id,
      patientData: data,
    };
  });
};

export const patientFileNoFieldsOptionsFormat = (response) => {
  return response?.map((data) => {
    return {
      label: `${data?.full_name} (${data?.file_no})${data?.old_file_no ? ` [Old: ${data.old_file_no}]` : ""}`,
      value: data?.patient_id,
      patientData: data,
    };
  });
};

export const patientMobileFieldsOptionsFormat = (response) => {
  return response?.map((data) => {
    return {
      label: `${data?.full_name} (${data?.contact})${data?.old_file_no ? ` [Old: ${data.old_file_no}]` : ""}`,
      value: data?.patient_id,
      patientData: data,
    };
  });
};

export const patientDocIdFieldsOptionsFormat = (response) => {
  return response?.map((data) => {
    return {
      label: `${data?.full_name} (${data?.document_id})${data?.old_file_no ? ` [Old: ${data.old_file_no}]` : ""}`,
      value: data?.patient_id,
      patientData: data,
    };
  });
};

export const searchedPatientsOptionsFormat = (response) => {
  return response?.map((data) => {
    const subscriberName =
      data?.subscriber_full_name || data?.subscriber?.full_name;
    const subscriberLabel = subscriberName
      ? ` -- Subscriber: ${subscriberName}`
      : "";

    return {
      label: `Name: ${data?.full_name} -- MRN: ${data?.file_no} -- Document Id: ${data?.document_id}${subscriberLabel}`,
      value: data?.patient_id,
      patientData: data,
    };
  });
};
export const approvalStatusOptions = (t) => [
  { label: t("Select Status"), value: "" },
  { label: t("Apprv"), value: "approved" },
  { label: t("Partial Apprv"), value: "partial Approved" },
  { label: t("Rejected"), value: "rejected" },
  { label: t("Pending"), value: "pending" },
];

export const searchedPriceItemsOptionsFormat = (response, payer_id) => {
  if (!Array.isArray(response) || !response.length) return [];
  return response.map((data) => {
    let selectedItemPayer = payer_id
      ? data?.payer_details?.find((p) => p?.payer_id === payer_id)
      : data?.payer_details?.[0];
    selectedItemPayer = selectedItemPayer || data?.payer_details?.[0];

    const descEn =
      data?.non_standard_description ||
      selectedItemPayer?.non_standard_description ||
      data?.standard_description ||
      "";
    const descAr =
      data?.non_standard_description_ar ||
      selectedItemPayer?.non_standard_description_ar ||
      "";
    const code =
      data?.non_standard_code ||
      selectedItemPayer?.non_standard_code ||
      data?.standard_code ||
      "";
    const itemName = data?.price_list_type?.name_en || "";

    return {
      label: `${itemName} (${code})   |   ${descEn}`,
      code,
      itemName,
      description: descEn,
      nameAr: descAr,
      value: data?.id,
      item: data,
    };
  });
};
export const searchedPriceItemsOptionsFormatConsultation = (response) => {
  if (!response?.length) return false;
  return response?.map((data) => {
    let selectedItemPayer = data?.payer_details?.[0];
    const descEn = selectedItemPayer?.non_standard_description || "";
    const descAr = selectedItemPayer?.non_standard_description_ar || "";
    const code =
      selectedItemPayer?.non_standard_code ||
      data?.non_standard_code ||
      data?.standard_code ||
      "";
    const itemName = data?.price_list_type?.name_en || "";
    return {
      label: `${itemName} (${code})   |   ${descEn}`,
      code,
      itemName,
      description: descEn,
      nameAr: descAr,
      value: data?.non_standard_code,
      item: data,
    };
  });
};
export const searchedPriceItemsOptionsFormatSFDA = (response) => {
  if (!Array.isArray(response?.data) || response?.data?.length === 0) return [];

  return response?.data?.map((data) => {
    const tradeName = data?.trade_name || data?.name || "";
    const genericName =
      data?.item_generic_name ||
      data?.generic_name ||
      data?.scientific_name ||
      "";
    const displayName = tradeName || genericName || "Unknown";

    return {
      label: displayName,
      displayName,
      tradeName,
      genericName,
      description:
        data?.second_description ||
        data?.pharmaceutical_form ||
        data?.administration_route ||
        "",
      value:
        data?.gtin ||
        data?.register_number ||
        data?.product_master_code ||
        "",
      item: data,
    };
  });
};

export const visitDiscountOptions = (t) => [
  { label: t("Percent"), value: "percentage" },
  { label: t("Fix"), value: "fixed" },
];

export const VisitsFormsTabs = (props = {}) => {
  let tabs = {
    tabs: [
      {
        name: t("Create New Entry"),
        content: (
          <CreateVisitFormEntries {...(props?.createEntryProps || {})} />
        ),
      },
      {
        name: t("View Saved Entries"),
        content: <ViewVisitFormEntries {...(props?.viewEntriesProps || {})} />,
      },
    ],
    className: "custom-class",
  };
  return tabs;
};
export const InPatientVisitsFormsTabs = (props = {}) => {
  let tabs = {
    tabs: [
      {
        name: t("Create New Entry"),
        content: <IpFormEntriesCreation {...(props?.createEntryProps || {})} />,
      },
      {
        name: t("View Saved Entries"),
        content: <ViewVisitFormEntries {...(props?.viewEntriesProps || {})} />,
      },
    ],
    className: "custom-class",
  };
  return tabs;
};

export const visitStatusFieldOptions = (t) => [
  { value: "Fulfilled", label: t("Fulfilled") },
  // { value: 'Cancelled', label: 'Cancelled' },
  { value: "Pending", label: t("Pending") },
  { value: "Waitlisted", label: t("Waitlisted") },
];

export const PatientAppointmentData = [
  {
    patient_id: "P001",
    full_name: "Tayab Mohammed",
    document_id: "DOC123456",
    gender: "male",
  },
  {
    patient_id: "P002",
    full_name: "Ibrahim farouk ",
    document_id: "DOC789101",
    gender: "female",
  },
  {
    patient_id: "P003",
    full_name: "Michael Johnson",
    document_id: "DOC112233",
    gender: "male",
  },
  {
    patient_id: "P004",
    full_name: "Emily Davis",
    document_id: "DOC445566",
    gender: "female",
  },
  {
    patient_id: "P005",
    full_name: "David Wilson",
    document_id: "DOC778899",
    gender: "male",
  },
  {
    patient_id: "P006",
    full_name: "Sophia Brown",
    document_id: "DOC101112",
    gender: "female",
  },
  {
    patient_id: "P007",
    full_name: "Chris Martin",
    document_id: "DOC131415",
    gender: "male",
  },
  {
    patient_id: "P008",
    full_name: "Olivia White",
    document_id: "DOC161718",
    gender: "female",
  },
  {
    patient_id: "P009",
    full_name: "James Anderson",
    document_id: "DOC192021",
    gender: "male",
  },
  {
    patient_id: "P010",
    full_name: "Emma Thompson",
    document_id: "DOC222324",
    gender: "female",
  },
];

export const visitTabs = (
  visitsData,
  isLoading,
  filtersPayload,
  practitionerDepartmentList,
  setFiltersPayload,
  t,
  order,
  orderData,
  getOrdersPayload,
  containerRef,
) => {
  return [
    {
      name: t("OutPatient"),
      content: (
        <VisitsList
          visitsData={visitsData}
          isLoading={isLoading}
          filtersPayload={filtersPayload}
          visit_category="out_patient"
          setFiltersPayload={setFiltersPayload}
          practitionerDepartmentList={practitionerDepartmentList}
          order={order}
          orderData={orderData}
          getOrdersPayload={getOrdersPayload}
          containerRef={containerRef}
        />
      ),
    },
    {
      name: t("Emergency"),
      content: (
        <VisitsList
          visitsData={visitsData}
          isLoading={isLoading}
          filtersPayload={filtersPayload}
          visit_category=""
          priority="EMERGENCY"
          practitionerDepartmentList={practitionerDepartmentList}
          setFiltersPayload={setFiltersPayload}
          order={order}
          orderData={orderData}
          getOrdersPayload={getOrdersPayload}
          containerRef={containerRef}
        />
      ),
    },
  ];
};
export const actPriorityOptions = (t) => [
  {
    label: t("ASAP"),
    value: "a",
    text: t("As soon as possible, next highest priority after stat."),
  },
  {
    label: t("CALLBACK RESULTS"),
    value: "cr",
    text: t(
      "Filler should contact the placer as soon as results are available, even for preliminary results.",
    ),
  },
  {
    label: t("ELECTIVE"),
    value: "el",
    text: t("Beneficial to the patient but not essential for survival."),
  },
  {
    label: t("EMERGENCY"),
    value: "em",
    text: t(
      "An unforeseen combination of circumstances or resulting state that calls for immediate action.",
    ),
  },
  {
    label: t("PREOP"),
    value: "p",
    text: t(
      "Used to indicate that a service is to be performed prior to a scheduled surgery.",
    ),
  },
  {
    label: t("PRN"),
    value: "prn",
    text: t(
      "As needed — should be accompanied by a description of what constitutes a need.",
    ),
  },
  {
    label: t("ROUTINE"),
    value: "r",
    text: t("Routine service, do at usual work hours."),
  },
  {
    label: t("RUSH REPORTING"),
    value: "rr",
    text: t("A report should be prepared and sent as quickly as possible."),
  },
  {
    label: t("STAT"),
    value: "s",
    text: t("With highest priority (e.g., emergency)."),
  },
  {
    label: t("TIMING CRITICAL"),
    value: "t",
    text: t(
      "It is critical to come as close as possible to the requested time (e.g., for a through antimicrobial level).",
    ),
  },
  {
    label: t("USE AS DIRECTED"),
    value: "ud",
    text: t("Drug is to be used as directed by the prescriber."),
  },
  {
    label: t("URGENT"),
    value: "ur",
    text: t("Calls for prompt action."),
  },
];

export const practitionersVisitTabs = (
  visitsData,
  isLoading,
  filtersPayload,
  setFiltersPayload,
  t,
  isPractitioner = false,
) => {
  const tabs = [
    {
      name: t("OutPatient"),
      content: (
        <VisitsList
          visitsData={visitsData}
          isLoading={isLoading}
          filtersPayload={filtersPayload}
          visit_category="out_patient"
          setFiltersPayload={setFiltersPayload}
        />
      ),
    },
    {
      name: t("Emergency"),
      content: (
        <VisitsList
          visitsData={visitsData}
          isLoading={isLoading}
          filtersPayload={filtersPayload}
          visit_category=""
          priority="EMERGENCY"
          setFiltersPayload={setFiltersPayload}
        />
      ),
    },
  ];

  if (isPractitioner) {
    tabs.push({
      name: t("is_temporary_followup"),
      content: (
        <VisitsList
          visitsData={visitsData}
          isLoading={isLoading}
          filtersPayload={filtersPayload}
          visit_category=""
          is_temporary_followup={true}
          setFiltersPayload={setFiltersPayload}
        />
      ),
    });
  }

  return tabs;
};

export const visitPaymentStatusOptions = [
  { value: "Paid", label: "Paid" },
  { value: "UnPaid", label: "UnPaid" },
];

export const departmensTreeData = [
  {
    key: "0",
    label: "Internal Medicine",
    data: "Department",
    icon: "pi pi-fw pi-folder",
    children: [
      { key: "0-0", label: "Dr. Faisal Al Saud", icon: "pi pi-fw pi-user" },
      { key: "0-1", label: "Dr. Amal Al Harbi", icon: "pi pi-fw pi-user" },
    ],
  },
  {
    key: "1",
    label: "Pediatrics",
    data: "Department",
    icon: "pi pi-fw pi-folder",
    children: [
      { key: "1-0", label: "Dr. Saud Al Ghamdi", icon: "pi pi-fw pi-user" },
      { key: "1-1", label: "Dr. Noura Al Qahtani", icon: "pi pi-fw pi-user" },
    ],
  },
  {
    key: "2",
    label: "Cardiology",
    data: "Department",
    icon: "pi pi-fw pi-folder",
    children: [
      {
        key: "2-0",
        label: "Dr. Abdullah Al Dossari",
        icon: "pi pi-fw pi-user",
      },
      { key: "2-1", label: "Dr. Maha Al Shammari", icon: "pi pi-fw pi-user" },
    ],
  },
  {
    key: "3",
    label: "Dermatology",
    data: "Department",
    icon: "pi pi-fw pi-folder",
    children: [
      { key: "3-0", label: "Dr. Khalid Al Anazi", icon: "pi pi-fw pi-user" },
      { key: "3-1", label: "Dr. Huda Al Suwaidi", icon: "pi pi-fw pi-user" },
    ],
  },
  {
    key: "4",
    label: "Orthopedics",
    data: "Department",
    icon: "pi pi-fw pi-folder",
    children: [
      { key: "4-0", label: "Dr. Turki Al Zahrani", icon: "pi pi-fw pi-user" },
      { key: "4-1", label: "Dr. Reem Al Amri", icon: "pi pi-fw pi-user" },
    ],
  },
  {
    key: "5",
    label: "Neurology",
    data: "Department",
    icon: "pi pi-fw pi-folder",
    children: [
      { key: "5-0", label: "Dr. Salman Al Jaber", icon: "pi pi-fw pi-user" },
      { key: "5-1", label: "Dr. Layla Al Bassam", icon: "pi pi-fw pi-user" },
    ],
  },
  {
    key: "6",
    label: "Radiology",
    data: "Department",
    icon: "pi pi-fw pi-folder",
    children: [
      { key: "6-0", label: "Dr. Ahmed Al Nasser", icon: "pi pi-fw pi-user" },
      { key: "6-1", label: "Dr. Dana Al Tamimi", icon: "pi pi-fw pi-user" },
    ],
  },
];

export const dummyVisitsData = [
  {
    time: "09:00 AM",
    practitioner: "Dr. Faisal Al Saud",
    patient: "Ali Khan",
    reason: "Routine Check-up",
  },
  {
    time: "09:30 AM",
    practitioner: "Dr. Amal Al Harbi",
    patient: "Fatima Noor",
    reason: "Flu Symptoms",
  },
  {
    time: "10:00 AM",
    practitioner: "Dr. Saud Al Ghamdi",
    patient: "Yasir Javed",
    reason: "Back Pain",
  },
  {
    time: "10:30 AM",
    practitioner: "Dr. Noura Al Qahtani",
    patient: "Mariam Zaid",
    reason: "Consultation",
  },
  {
    time: "11:00 AM",
    practitioner: "Dr. Abdullah Al Dossari",
    patient: "Omar Rafiq",
    reason: "Follow-up",
  },
  {
    time: "11:00 AM",
    practitioner: "Dr. Abdullah Al Dossari",
    patient: "Omar Rafiq",
    reason: "Follow-up",
  },
  {
    time: "11:00 AM",
    practitioner: "Dr. Abdullah Al Dossari",
    patient: "Omar Rafiq",
    reason: "Follow-up",
  },
];

export const StatsData = (data, t) => [
  {
    label: t("active_days"),
    value: data?.total_active_days ?? "--",
    color: "bg-sky-100",
    icon: <FaCalendarAlt className="text-sky-600" />,
  },
  {
    label: t("total_slots"),
    value: data?.total_slots ?? "--",
    color: "bg-violet-100",
    icon: <FaCalendarDay className="text-violet-600" />,
  },
  {
    label: t("available"),
    value: data?.total_available_slots ?? "--",
    color: "bg-emerald-100",
    icon: <FaCalendarCheck className="text-emerald-600" />,
  },
  {
    label: t("booked"),
    value: data?.total_booked_slots ?? "--",
    color: "bg-rose-100",
    icon: <FaUserMd className="text-rose-600" />,
  },
  {
    label: t("Appointments"),
    value: data?.total_appointments ?? "--",
    color: "bg-orange-100",
    icon: <FaCalendarTimes className="text-orange-600" />,
  },
  {
    label: t("Visits"),
    value: data?.total_visits ?? "--",
    color: "bg-teal-100",
    icon: <FaUsers className="text-teal-600" />,
  },
  {
    label: t("Doctors Checkup"),
    value: data?.doctors_checkup ?? "--",
    color: "bg-sky-100",
    icon: <FaUserMd className="text-sky-600" />,
  },
  {
    label: t("Waiting"),
    value: data?.waiting ?? "--",
    color: "bg-amber-100",
    icon: <FaUserClock className="text-amber-600" />,
  },
];
export const VisitHistoryColumns = (t) => [
  {
    body: sequenceTableTemplate,
    header: t("No"),
    style: { width: "3rem" },
  },
  {
    header: t("Visit Date"),
    body: (rowData) => formatDate(rowData?.visit_date),
  },
  {
    header: t("Visit Number"),
    body: (rowData) => rowData?.visit_id,
  },
  {
    header: t("Patient Name"),
    body: (rowData) => rowData?.patient?.full_name,
  },

  {
    header: t("Practitioner"),
    body: (rowData) => rowData?.practitioner?.name,
  },
  {
    header: t("Specialty"),
    body: (rowData) => rowData?.practitioner?.speciality?.name_en,
  },
  {
    header: t("Visit Type"),
    body: (rowData) => rowData?.visit_type?.type,
  },
  {
    header: t("Status"),
    body: (rowData) => rowData?.status,
  },
  {
    header: t("Payment Status"),
    body: (rowData) => rowData?.payment_status,
  },
  {
    header: t("Token Number"),
    body: (rowData) => rowData?.token?.token_number,
  },
  {
    header: t("Service Item"),
    body: (rowData) => (
      <div className="flex flex-col">
        {rowData?.items?.map((item, index) => (
          <span>
            {item?.item_name +
              (index < rowData?.items?.length - 1 ? "  , " : "")}
          </span>
        ))}
      </div>
    ),
  },
];

export const getPatientDetails = (visitData, t) => {
  return [
    {
      label: t("Patient Name"),
      text: visitData?.patient?.full_name || "--",
    },
    {
      label: t("Beneficiary Type"),
      text: visitData?.patient?.beneficiary_type || "--",
    },
    {
      label: t("Document ID"),
      text: visitData?.patient?.document_id || "--",
    },
    {
      label: t("MRN"),
      text: visitData?.patient?.file_no || "--",
    },
    {
      label: t("MRN"),
      text: visitData?.patient?.mrn || "--",
    },
    {
      label: t("Gender"),
      text: visitData?.patient?.gender || "--",
    },
    {
      label: t("Date of Birth"),
      text: visitData?.patient?.dob
        ? new Date(visitData.patient.dob).toLocaleDateString()
        : "--",
    },
    {
      label: t("Contact"),
      text: visitData?.patient?.contact || "--",
    },
    {
      label: t("Nationality"),
      text: visitData?.patient?.nationality || "--",
    },
  ];
};

export const getVisitDetails = (visitData, t) => {
  return [
    {
      label: t("Visit Date"),
      text: formatDate(visitData?.visit_date) || "--",
    },
    {
      label: t("Visit Number"),
      text: visitData?.visit_id || "--",
    },
    {
      label: t("Token Number"),
      text: visitData?.token?.token_number || visitData?.token_number || "--",
    },
    {
      label: t("Episode type"),
      text: visitData?.episode_type || "--",
    },
    {
      label: t("Practitioner"),
      text: visitData?.practitioner?.name || "--",
    },
    {
      label: t("Specialty"),
      text: visitData?.practitioner?.speciality?.name_en || "--",
    },
    {
      label: t("Department"),
      text: visitData?.practitioner?.department?.name_en || "--",
    },
    {
      label: t("License"),
      text: visitData?.practitioner?.license || "--",
    },
    {
      label: t("Visit Type"),
      text: visitData?.visit_type?.type || "--",
    },
    {
      label: t("Status"),
      text: visitData?.status || "--",
    },
    {
      label: t("Payment Status"),
      text: visitData?.payment_status || "--",
    },
    {
      label: t("Payment Method"),
      text: visitData?.payment_method || "--",
    },
    {
      label: t("Created By"),
      text: visitData?.created_by || "--",
    },
  ];
};

export const ServiceItemColumns = (t) => [
  {
    body: sequenceTableTemplate,
    header: t("No"),
    style: { width: "3rem" },
  },
  {
    header: t("Item Name"),
    body: (rowData) => rowData?.item_name || "--",
  },
  {
    header: t("Code"),
    body: (rowData) => rowData?.non_standard_code || "--",
  },
  {
    header: t("Description"),
    body: (rowData) => rowData?.non_standard_description || "--",
  },
  {
    header: t("Quantity"),
    body: (rowData) => rowData?.quantity || "--",
  },
  {
    header: t("Unit Price"),
    body: (rowData) =>
      rowData?.unit_price ? `${rowData.unit_price} SAR` : "--",
  },
  {
    header: t("Status"),
    body: (rowData) => (
      <span
        className={`px-2 py-1 rounded-full text-xs ${
          rowData?.status === "Paid"
            ? "bg-green-100 text-green-800"
            : "bg-yellow-100 text-yellow-800"
        }`}
      >
        {rowData?.status || "--"}
      </span>
    ),
  },
  {
    header: t("Patient Share"),
    body: (rowData) =>
      rowData?.patient_share ? `${rowData.patient_share} SAR` : `0 SAR`,
  },
  {
    header: t("Discount"),
    body: (rowData) =>
      rowData?.discount_amount ? `${rowData.discount_amount} SAR` : `0 SAR`,
  },
  {
    header: t("Vat"),
    body: (rowData) =>
      rowData?.tax_amount ? `${rowData.tax_amount} SAR` : `0 SAR`,
  },
];

export const getGroupByTabs = (
  t,
  visitData,
  isAdmin,
  isManager,
  isReceptionist,
  isAddCheckBox,
  isAlowActions,
  priceListType,
  setBillingVisitData,
  isAccountant,
  itemsLoading,
) => {
  if (itemsLoading) {
    return [
      {
        name: t("Loading..."),
        content: (
          <div className="w-full border border-gray-200 mt-2 overflow-auto max-[300px] xl:max-h-[400px]">
            <table className="w-full">
              <thead className="rounded !px-4 sticky top-0 z-10">
                <tr>
                  {isAddCheckBox && (
                    <th className="table-header !font-bold"></th>
                  )}
                  <th className="table-header !font-bold ps-3">{t("Code")}</th>
                  <th className="table-header !font-bold min-w-[200px]">
                    {t("Name")}
                  </th>
                  <th className="table-header !font-bold">{t("Type")}</th>
                  <th className="table-header !font-bold">{t("Sessions")}</th>
                  <th className="table-header !font-bold">{t("U.Price")}</th>
                  <th className="table-header !font-bold">{t("S.Price")}</th>
                  <th className="table-header !font-bold">{t("Qty")}</th>
                  <th className="table-header !font-bold">{t("Disc")}</th>
                  <th className="table-header !font-bold">{t("Vat")}</th>
                  <th className="table-header !font-bold">{t("Apprv.")}</th>
                  {isAlowActions && (
                    <th className="table-header !font-bold">{t("Actions")}</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {[...Array(5)].map((_, i) => (
                  <tr key={i} className="bg-white border-b">
                    {isAddCheckBox && (
                      <td className="ps-2 py-4">
                        <div className="h-4 w-4 bg-gray-200 rounded animate-pulse"></div>
                      </td>
                    )}
                    <td className="ps-3 py-4">
                      <div className="h-4 w-12 bg-gray-200 rounded animate-pulse"></div>
                    </td>
                    <td className="py-4">
                      <div className="h-4 w-40 bg-gray-200 rounded animate-pulse"></div>
                    </td>
                    <td className="py-4">
                      <div className="h-4 w-16 bg-gray-200 rounded animate-pulse"></div>
                    </td>
                    <td className="py-4">
                      <div className="h-4 w-8 bg-gray-200 rounded animate-pulse mx-auto"></div>
                    </td>
                    <td className="py-4">
                      <div className="h-10 w-20 bg-gray-100 rounded animate-pulse"></div>
                    </td>
                    <td className="py-4">
                      <div className="h-10 w-20 bg-gray-100 rounded animate-pulse"></div>
                    </td>
                    <td className="py-4">
                      <div className="h-10 w-20 bg-gray-100 rounded animate-pulse"></div>
                    </td>
                    <td className="py-4">
                      <div className="h-10 w-32 bg-gray-100 rounded animate-pulse"></div>
                    </td>
                    <td className="py-4">
                      <div className="h-8 w-12 bg-gray-100 rounded animate-pulse"></div>
                    </td>
                    <td className="py-4">
                      <div className="h-8 w-12 bg-gray-100 rounded animate-pulse"></div>
                    </td>
                    {isAlowActions && (
                      <td className="py-4">
                        <div className="flex justify-center py-4">
                          <div className="h-4 w-4 bg-gray-200 rounded animate-pulse"></div>
                        </div>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ),
      },
    ];
  }

  const groupItems = groupByItemType(
    visitData?.items?.filter(
      (item) => item?.status?.toLowerCase() === "unpaid",
    ) || [],
  );

  return Object.keys(groupItems).map((key) => {
    const items = groupItems[key];
    const haveCash = items.some((item) => item?.item_category === "cash");
    const haveInsurance = items.some((item) => item?.item_category != "cash");
    const hasChildren = haveCash && haveInsurance;

    const tabName =
      priceListType?.find((it) => it?.value === key)?.label ||
      `${key} (${items?.length})`;

    const renderTable = (itemsToRender) => (
      <PayBillItemsTable
        items={itemsToRender}
        isAddCheckBox={isAddCheckBox}
        isAlowActions={isAlowActions}
        isAdmin={isAdmin}
        isManager={isManager}
        isReceptionist={isReceptionist}
        isAccountant={isAccountant}
        setBillingVisitData={setBillingVisitData}
        billingVisitData={visitData}
        itemsLoading={itemsLoading}
      />
    );

    return {
      name: t(tabName),
      ...(hasChildren
        ? {
            children: [
              {
                name: t("Cash Items"),
                content: renderTable(
                  items.filter((i) => i.item_category === "cash"),
                ),
              },
              {
                name: t("Insurance Items"),
                content: renderTable(
                  items.filter((i) => i.item_category != "cash"),
                ),
              },
            ],
          }
        : {
            content: renderTable(items),
          }),
    };
  });
};

// export const getGroupByTabs = (
//   t,
//   visitData,
//   isAdmin,
//   isReceptionist,
//   isAddCheckBox,
//   isAlowActions,
//   priceListType
// ) => {
//   const groupItems = groupByItemType(
//     visitData?.items?.filter(
//       (item) => item?.status?.toLowerCase() == "unpaid"
//     ) || []
//   );
//   const groupedTabs = Object.keys(groupItems).map((key) => {
//     const haveCash = groupItems[key]?.some(
//       (item) => item?.item_category === "cash"
//     );
//     const haveInsurance = groupItems[key]?.some(
//       (item) => item?.item_category === "insurance"
//     );
//     const Children = haveCash && haveInsurance;

//     return {
//       name: t(
//         priceListType?.find((it) => it?.value === key)?.label ||
//           key + `(${groupItems[key]?.length})`
//       ),
//       ...(Children && {
//         children: [
//           {
//             name: t("Cash Items"),
//             content: (
//               <PayBillItemsTable
//                 isAddCheckBox={isAddCheckBox}
//                 isAlowActions={isAlowActions}
//                 isAdmin={isAdmin}
//                 isReceptionist={isReceptionist}
//               />
//             ),
//           },
//           {
//             name: t("Insurance Items"),
//             content: (
//               <PayBillItemsTable
//                 isAddCheckBox={isAddCheckBox}
//                 isAlowActions={isAlowActions}
//                 isAdmin={isAdmin}
//                 isReceptionist={isReceptionist}
//               />
//             ),
//           },
//         ],
//       }),
//       content: (
//         <PayBillItemsTable
//           isAddCheckBox={isAddCheckBox}
//           isAlowActions={isAlowActions}
//           isAdmin={isAdmin}
//           isReceptionist={isReceptionist}
//         />
//       ),
//     };
//   });
//   return groupedTabs;
// };
const formatCardOptions = (apiData = []) => {
  if (!Array.isArray(apiData)) return [];

  const grouped = {};

  apiData.forEach((item) => {
    if (!item || typeof item !== "object") return;
    // Only include enabled card types
    if (item.enable !== true) return;

    const type = item.type?.trim();
    const label = item.name?.trim();
    const value = item.value ?? "";
    if (!type || !label) return;

    if (!grouped[type]) {
      grouped[type] = [];
    }

    grouped[type].push({
      label,
      value,
      cost: Number(item.cost) ?? null,
    });
  });

  return Object.keys(grouped).map((type) => ({
    label: type,
    options: grouped[type],
  }));
};

export const getCardOptions = async (setCardOptions, practitionerData = {}) => {
  try {
    const response = await fetchData(
      "POST",
      `/v3/card_types/seed_or_list?department_id=${practitionerData?.department?.id || ""}`,
      {},
    );
    if (response?.data?.length) {
      const formattedData = formatCardOptions(response?.data);
      setCardOptions(formattedData);
    }
  } catch (error) {
    console.log(error);
  }
};

export const getCardCost = (cardOptions, cardType, invoiceAmount) => {
  if (!cardOptions || !cardType || !invoiceAmount) return 0;
  const selectedCard = cardOptions
    ?.flatMap((group) => group.options)
    ?.find((option) => option.label === cardType || option.value === cardType);

  if (!selectedCard?.cost) return 0;
  return (Number(invoiceAmount) * Number(selectedCard.cost)) / 100;
};

export const getFixedCardCost = (cardOptions, cardType) => {
  if (!cardOptions || !cardType) return 0;

  const selectedCard = cardOptions
    ?.flatMap((group) => group.options)
    ?.find((option) => option.label === cardType || option.value === cardType);

  return selectedCard?.cost || 0;
};

export const getCardCostPercentage = (cost = 0, invoiceAmount = 0) => {
  if (!cost || !invoiceAmount) return 0;

  return (Number(invoiceAmount) * Number(cost)) / 100;
};
